/* tslint:disable */

declare var Object: any;
export interface SurveyServiceInterface {
  "id"?: number;
}

export class SurveyService implements SurveyServiceInterface {
  "id": number;
  constructor(data?: SurveyServiceInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `SurveyService`.
   */
  public static getModelName() {
    return "SurveyService";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of SurveyService for dynamic purposes.
  **/
  public static factory(data: SurveyServiceInterface): SurveyService{
    return new SurveyService(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'SurveyService',
      plural: 'SurveyServices',
      path: 'SurveyServices',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/SurveyService.ts